// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"AX-z","sponsoredTooltipWrapper":"BX-z","sponsoredTooltip":"CX-z","newCard":"DX-z"};